import React from 'react';
import CancelIcon from '@mui/icons-material/Cancel';
import InsertDriveFileRoundedIcon from '@mui/icons-material/InsertDriveFileRounded';
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import WhatsappIcon from '@mui/icons-material/WhatsApp';
import StatusIcon from 'src/components/StatusIcon';
import { CdfiStatus, CFDIListActions, InvoiceTypes } from './constants/cfdi';
import { IconStatusAndColor } from './constants/common';

export const getCFDIListOptions = (document, client, invoiceType, status) => {
  return [
    {
      name: CFDIListActions.VIEW_PDF,
      label: `ENUMS.CFDI_LIST_ACTIONS.${CFDIListActions.VIEW_PDF}`,
      icon: <InsertDriveFileRoundedIcon />,
      disabled: !document,
      message: 'COMMON.NO_DOCUMENTS_AVAILABLE'
    },
    {
      name: CFDIListActions.SEND_EMAIL,
      label: `ENUMS.CFDI_LIST_ACTIONS.${CFDIListActions.SEND_EMAIL}`,
      disabled: !document || !client,
      message: !document
        ? 'COMMON.NO_DOCUMENTS_AVAILABLE'
        : 'COMMON.NO_CLIENT_ASSOCIATED',
      icon: <SendRoundedIcon />
    },
    {
      name: CFDIListActions.SEND_WHATSAPP,
      label: `ENUMS.CFDI_LIST_ACTIONS.${CFDIListActions.SEND_WHATSAPP}`,
      disabled: !document || !client,
      message: !document
        ? 'COMMON.NO_DOCUMENTS_AVAILABLE'
        : 'COMMON.NO_CLIENT_ASSOCIATED',
      icon: <WhatsappIcon />
    },
    {
      name: CFDIListActions.CANCEL,
      disabled: status === CdfiStatus.CANCELLED,
      label:
        invoiceType === InvoiceTypes.PAYMENT
          ? `ENUMS.CFDI_LIST_ACTIONS.${CFDIListActions.CANCEL_RECEIPT}`
          : `ENUMS.CFDI_LIST_ACTIONS.${CFDIListActions.CANCEL_INVOICE}`,
      message:
        invoiceType === InvoiceTypes.PAYMENT
          ? `ENUMS.CFDI_LIST_ACTIONS.${CFDIListActions.CANCEL_RECEIPT}`
          : `ENUMS.CFDI_LIST_ACTIONS.${CFDIListActions.CANCEL_INVOICE}`,
      icon: <CancelIcon />
    }
  ];
};

export const selectIconFromCfdiStatus = status => {
  switch (status) {
    case CdfiStatus.VALID:
      return (
        <StatusIcon
          description="CFDI_VIEWS.STATUS.VALID"
          type={IconStatusAndColor.OK.status}
        />
      );
    case CdfiStatus.CANCELLED:
      return (
        <StatusIcon
          description="CFDI_VIEWS.STATUS.CANCELLED"
          type={IconStatusAndColor.ERROR.status}
        />
      );
    case CdfiStatus.PENDING_CANCELLATION:
      return (
        <StatusIcon
          description="CFDI_VIEWS.STATUS.PENDING_CANCELLATION"
          type={IconStatusAndColor.WARNING.status}
        />
      );
    default:
      return <StatusIcon type={IconStatusAndColor.NONE.status} />;
  }
};
